import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ITeamMember } from "../teamMemberModal";

export const getAllTeamMembers = createAsyncThunk(
  "TeamMember/FindAllTeamMembers",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/FindAllTeamMembers`,
        {
          TeamMemberName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching TeamMember Logos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTeamMember = createAsyncThunk(
  "TeamMember/InsertTeamMember",
  async (TeamMemberData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/InsertTeamMember`,
        TeamMemberData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating TeamMember logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTeamMember = createAsyncThunk(
  "TeamMember/UpdateTeamMember",
  async (TeamMemberData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/UpdateTeamMember`,
        TeamMemberData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating TeamMember logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTeamMember = createAsyncThunk(
  "TeamMember/DeleteTeamMember",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/DeleteTeamMember`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting TeamMember logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTeamMemberByID = createAsyncThunk(
  "TeamMember/FindByIDTeamMember",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/FindByIDTeamMember`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result?.Name,
        Title: result?.Title,
        Email: result?.Email,
        Image: result?.Image,
        Message: result?.Message,
        PhoneNo: result?.PhoneNo,
        Whatsapp: result?.Whatsapp,
        Linkedin: result?.Linkedin,
        Skype: result?.Skype,
        IsActive: result.IsActive ? 1 : 2,
      } as ITeamMember;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching TeamMember logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTeamMembers = createAsyncThunk(
  "TeamMember/FindAllActiveTeamMember",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/TeamMember/FindAllActiveTeamMember`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching TeamMember Logos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveTeamMember = createAsyncThunk(
  "TeamMember/ActiveInActiveTeamMember",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/ActiveInActiveTeamMember`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive TeamMember logo :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const TeamMemberImageUpload = createAsyncThunk(
  "TeamMember/TeamMemberImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TeamMember/TeamMemberImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload TeamMember logo Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
